<div class="work-popup edit-modal modal-dialog">
  <div class="modal-content">
    <div class="name_icon">
      <div class="name-icon-title">
        <div><p class="fs-14">Edit Hashtag</p></div>
        <div>
          <img class="close-icon" src="assets/svg/close.svg" alt="close svg" (click)="closePopUp()">
        </div>
      </div>
    </div>

    <div class="edit-content-container">
      <form [formGroup]="contentForm" (ngSubmit)="onSubmit()" class="edit-content">
        <div class="form-group padding-bottom-custom">
          <input class="form-control" type="text" tabindex="-1" formControlName="name" placeholder="Hashtag new name"
                 [ngClass]="{'has-error': editContentControl['name'].invalid && editContentControl['name'].touched}"
                 maxlength="26">
          @if (editContentControl['name'].invalid && editContentControl['name'].touched) {
            <div class="validation">
              @if (editContentControl['name'].errors!['required'] || editContentControl['name'].errors!['whitespace']) {
                <small class="flexed-small">Name is required</small>
              }
              @if (editContentControl['name'].errors!['minlength']) {
                <small class="flexed-small">Name should be at least 2 characters.</small>
              }
              @if (editContentControl['name'].errors!['maxlength']) {
                <small class="flexed-small">Name cannot exceed 25 characters.</small>
              }
              @if (editContentControl['name'].errors?.['onlyLetters']) {
                <small class="flexed-small">Name should contain only letters.</small>
              }
              @if (editContentControl['name'].errors?.['alreadyExists']) {
                <small class="flexed-small">Hashtag with this name already exists.</small>
              }
            </div>
          }
        </div>

        <div class="form-group cancel_save">
          <button type="button" class="btn btn-outline-danger" (click)="closePopUp()">Cancel</button>
          <button type="button" class="btn btn-outline-success" (click)="onSubmit()">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>
